import { useDispatch } from "react-redux";
import { addElementsToExcalidraw, createTextElement, duplicateElements, parseTextToJsonOrString } from "../../utils";
import { showErrorNotification } from "../../../notifications/actions";
import { NOTIFICATION_TIMEOUT_TYPE } from "../../../notifications/constants";
import { shareBlobImage, shareUrlImage } from "../../../collab-images/actions";
export function useWhiteboardPaste(excalidrawApi) {
    const dispatch = useDispatch();
    class PasteError extends Error {
        constructor(message) {
            super(message);
        }
    }
    async function addToExcalidraw(item) {
        try {
            const { type } = item;
            switch (type) {
                case 'text/html':
                    return await handleTextHtmlCase(item);
                case 'text/plain':
                    return await handleTextPlainCase(item);
                case 'image/jpeg':
                case 'image/png':
                case 'image/webp':
                    return await handleImageCase(item);
                default:
                    throw new PasteError('Elemento no soportado');
            }
        }
        catch (e) {
            let description = e instanceof PasteError ? e.message : 'Error desconocido al pegar';
            dispatch(showErrorNotification({
                title: "Error",
                description,
                hideErrorSupportLink: true,
            }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
        }
    }
    async function handleTextHtmlCase(item) {
        const html = await item.getText();
        if (!html)
            throw new PasteError('HTML not found');
        const imgElement = new DOMParser().parseFromString(html, 'text/html').querySelector('img[src]');
        if (!imgElement)
            throw new PasteError('Image not found on HTML');
        const src = imgElement.getAttribute('src');
        if (!src)
            throw new PasteError('image do not have src');
        const url = (() => { try {
            return new URL(src);
        }
        catch {
            throw new PasteError('image src is not a url');
        } })();
        if (!(url.protocol == "http:" || url.protocol == "https:")) {
            throw new PasteError(`Protocolo ${url.protocol} no soportado.`);
        }
        dispatch(shareUrlImage(url.toString(), excalidrawApi));
    }
    async function handleImageCase(item) {
        const blob = await item.getBlob();
        if (!blob)
            throw new PasteError('No blob');
        dispatch(shareBlobImage(blob, excalidrawApi));
    }
    async function handleTextPlainCase(item) {
        const text = await item.getText();
        if (!text)
            throw new PasteError('No text');
        const result = parseTextToJsonOrString(text);
        if (result.type == 'string') {
            addElementsToExcalidraw(excalidrawApi, createTextElement({ text }));
            return;
        }
        else {
            if (result.content.type !== "excalidraw/clipboard") {
                addElementsToExcalidraw(excalidrawApi, createTextElement({ text }));
                return;
            }
            const { files, elements } = result.content;
            if (files) {
                excalidrawApi.addFiles(Object.values(files));
            }
            if (elements) {
                const newElements = duplicateElements(elements);
                addElementsToExcalidraw(excalidrawApi, newElements);
                excalidrawApi.updateScene({
                    appState: {
                        selectedElementIds: Object.fromEntries(newElements.map(el => [el.id, true]))
                    }
                });
            }
        }
    }
    return {
        addToExcalidraw
    };
}
